module.exports = __webpack_public_path__ + "img/026.484ab40e.png";